export const TAB_LOCATIONS = 0;
export const TAB_CATEGORIES = 1;
export const TAB_SUB_CATEGORIES = 2;
export const TAB_TEAMS = 3;

export const PATH_TAB_INDEX = {
  [TAB_LOCATIONS]: '/locations',
  [TAB_CATEGORIES]: '/categories',
  [TAB_SUB_CATEGORIES]: '/subcategories',
  [TAB_TEAMS]: '/teams',
};
